module.exports = __webpack_public_path__ + "img/viano.d2b5842a.jpg";